import React, { Fragment, useState, useMemo, useEffect, useCallback, useRef, memo } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import Logo from './../assist/triokzzlohgo.svg';
import Hnadcrafted from '../assist/handicrafted_item.jpg';
import toast, { Toaster } from 'react-hot-toast';
import Registration from './registration';
import { StarIcon } from '@heroicons/react/20/solid';
import SignInForm from './../admin/signin'

function OfferCard({ navItem, setShowChild }) {
  const [open, setOpen] = useState(true)

  const close = () => {
    setShowChild(false)
    setOpen(false)
  }
  const copytoclipboard = () => {
    navigator.clipboard.writeText("TRIOK10")
    toast('Copied to Clipboard !')
  }


  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-40" onClose={() => !close}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-40 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <div className="flex h-full flex-col bg-white shadow-xl">
                  <div className="flex-1 overflow-y-auto px-1 py-6 sm:px-4">
                    <div className="flex items-start justify-between">
                      <Dialog.Title className="text-lg font-medium text-blue-900"></Dialog.Title>
                      {/* <div className="ml-3 flex h-7 items-center">
                        <button
                          type="button"
                          className="relative -m-2 p-2 text-red-400 hover:text-gray-500"
                          onClick={() => close()}
                        >
                          <span className="absolute -inset-0.5" />
                          <span className="sr-only">Close panel</span>
                          <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                      </div> */}
                    </div>

                    <div className="relative grid grid-cols-1 w-full">
                      <div className="container mx-auto">
                        <div className="bg-gradient-to-br from-purple-600 to-indigo-600 text-white text-center py-1 px-2 rounded-lg shadow-md relative">
                          <div className="confetti">
                            <div className="confetti-piece">
                            </div>
                            <div className="confetti-piece"></div>
                            <div className="confetti-piece"></div>
                            <div className="confetti-piece"></div>
                            <div className="confetti-piece"></div>
                            <div className="confetti-piece"></div>
                            <div className="confetti-piece"></div>
                            <div className="confetti-piece"></div>
                            <div className="confetti-piece"></div>
                            <div className="confetti-piece"></div>
                            <div className="confetti-piece"></div>
                            <div className="confetti-piece"></div>
                            <div className="confetti-piece"></div>
                          </div>
                          <img src={Logo} className="w-20 mx-auto mb-2 rounded-lg" />
              
                          <section id="download" className="bg-gray-900">
                      
                            <div className="max-w-7xl px-2 sm:px-6 lg:px-8">
                              <div
                                className="relative mx-4 overflow-hidden px-4 py-2 sm:-mx-6 sm:px-6  xl:px-5 xl:py-5">
                                <div className="relative mx-auto grid max-w-2md gap-x-2 gap-y-2 text-center xl:max-w-none">
                                {/* <SignInForm  close={()=>close()}/> */}
                                {/* <p>Verify</p> */}
                                  <Registration close={()=>close()}/>
                                    <p className="relative text-[9px] font-bold">The final price shown after checkout <span className='text-[9px]'>(Coupon Applied On Online Payment)</span></p>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>

          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
export default memo(OfferCard)